import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { DispatcherScopeService } from "../services/dispatcher-scope.service";

@Injectable()
export class DispatcherScopeInterceptor implements HttpInterceptor {
  constructor(private scope: DispatcherScopeService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes("/api/")) return next.handle(req);
    if (req.url.includes("/api/dispatcher/me/cities")) return next.handle(req);
    if (req.url.includes("/auth/login")) return next.handle(req);

    const cityId = this.scope.currentCityId();
    const countryId = this.scope.currentCountryId();
    if (!cityId && !countryId) return next.handle(req);

    let params = req.params;
    if (cityId && !params.has("cityId")) params = params.set("cityId", cityId);
    if (countryId && !params.has("countryId")) params = params.set("countryId", countryId);
    return next.handle(req.clone({ params }));
  }
}
